module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zl_nor.cb973267.png";